module.exports = __webpack_public_path__ + "static/media/elec-dashboard.229bdc82.svg";